import { useEffect, useState } from "react"
import { classNames } from "~/utils/classNames";
import { formatCurrency } from "~/utils/formatter/currency";
import { useShoppingCart } from "~/utils/context/useShoppingCart";
import InputError from "../Form/InputError";
import ProductList from "./ProductList";
import { currency } from "~/utils/types/currency";
export default function Cart({ currency, currencyRate, currencyDetailsInUSD, setSubButtonMessage, order }: { currency: string, currencyRate: number, currencyDetailsInUSD: currency, setSubButtonMessage: React.Dispatch<React.SetStateAction<string>>, order?: any }) {

    const { orderTotal, subTotal, shippingCosts, categories, shippingHasError, cardTotal, checkIfCartHasSupporterPack, setCartItems, checkIfOrderHasActivationCosts, addActivationCosts, getActivationCosts } = useShoppingCart();
    const [activePack, setActivePack] = useState(categories[0].name)

    useEffect(() => {
        if (cardTotal > 1) {
            if (shippingCosts > 0 || checkIfCartHasSupporterPack() && !shippingHasError) {
                setSubButtonMessage('Payment fees are calculated at checkout.');
            } else {
                setSubButtonMessage('Please fill in your shipping details and calculate your shipping costs.');
            }
        }
    }, [cardTotal])

    useEffect(() => {
        if (order) {
            setCartItems(order.orderLines);
        }
        if (!checkIfOrderHasActivationCosts()) {
            addActivationCosts({
                title: 'Activation Costs for one card',
                price: parseFloat(currencyDetailsInUSD.XRP.toFixed(2)),
                quantity: 1,
                id: 'activationCosts',
                type: 'activationCosts'
            })
        }
    }, [])

    return (
        <div className="grid-cols-4 col-span-2 mb-8 lg:grid lg:gap-x-12 xl:gap-x-16">
            <div className="col-span-3 relative">
                <div>
                    <h3 className="sr-only">Select items in your cart</h3>
                    {categories.map((category: any) => {
                        return (
                            <ProductList key={category.name} activePack={activePack} pack={category} />
                        )
                    })}
                    <div className="h-full w-[1px] bg-black/10 absolute -right-8 top-0"></div>
                </div>
            </div>

            <div className="mt-12 lg:mt-[52px] rounded-lg border border-gray-200 bg-white shadow-md h-fit">
                <dl className="px-4 py-6 space-y-6 border-gray-200 sm:px-6">
                    <div className="flex items-start justify-between">
                        <dt className="text-sm">Subtotal <br /> {cardTotal > 0 && <span className="text-sm font-semibold text-black/40">{checkIfCartHasSupporterPack() ? cardTotal + 4 : cardTotal} card{checkIfCartHasSupporterPack() ? 's' : cardTotal > 1 && 's'}</span>}</dt>
                        <dd className="text-sm font-medium text-gray-900">{formatCurrency('USD', subTotal)}</dd>
                    </div>
                    {checkIfOrderHasActivationCosts() && (
                        <div className="flex items-start justify-between">
                            <dt className="text-sm">Activation Costs <br /> <span className="text-sm text-black/40 font-semibold">For one card only</span></dt>
                            <dd className="text-sm font-medium text-gray-900">{formatCurrency('USD', getActivationCosts())}</dd>
                        </div>
                    )}
                    <div className="flex items-center justify-between">
                        <dt className={`text-sm ${shippingHasError ? 'text-red-600 font-bold' : ''}`}>Shipping
                            {shippingHasError &&
                                <InputError message="Please select a shipping method" />
                            }
                        </dt>
                        <dd className="text-sm font-medium text-gray-900">{formatCurrency('USD', shippingCosts)}</dd>
                    </div>
                    <div className="flex items-center justify-between pt-6 border-t border-gray-200">
                        <dt className="text-base font-medium">Total {currency !== 'USD' && orderTotal !== 0 &&
                            <small className="ml-1 text-gray-900/70">~
                                {
                                    formatCurrency(currency, orderTotal * currencyRate)
                                }
                            </small>
                        }
                        </dt>
                        <dd className="text-base font-medium text-gray-900">{formatCurrency('USD', orderTotal)}</dd>
                    </div>
                </dl>
            </div >
        </div >
    )
};
